// extracted by mini-css-extract-plugin
module.exports = {"headerLogo":"header-module--header-logo--2hrDl"};